import get from 'lodash/get';
import isArray from 'lodash/isArray';
import isEmpty from 'lodash/isEmpty';
import isPlainObject from 'lodash/isPlainObject';
import isString from 'lodash/isString';
import mapValues from 'lodash/mapValues';

export function isEmptyString(str) {
  return isString(str) && isEmpty(str);
}
/**
 * Returns a copy of 'obj' with all entries containing empty string values removed
 * @param obj - any object
 * @param {object} settings
 * @param {boolean} settings.recursive - Removes empty strings from all nested objects as well.
 * @return {object}
 */
export function removeEmptyStrings(obj, settings = {recursive: false}) {
  return mapValues(obj, (value) => {
    if (settings.recursive) {
      if (isPlainObject(value)) {
        return removeEmptyStrings(value, settings);
      } else if (isArray(value)) {
        return value.map((arrayEntry) => removeEmptyStrings(arrayEntry, settings));
      }
    }

    if (isEmptyString(value)) {
      return undefined;
    } else {
      return value;
    }
  });
}

export function createFieldToWatchFunction(fieldPath) {
  return (prevValues, curValues) => {
    return get(prevValues, fieldPath) !== get(curValues, fieldPath);
  };
}
